import { render } from "./BillingRevenueReport.vue?vue&type=template&id=0f10754c"
import script from "./BillingRevenueReport.vue?vue&type=script&lang=js"
export * from "./BillingRevenueReport.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"BillingRevenueReport.vue"]])

export default __exports__